import Enum from './enum'

class SortOrder extends Enum
{
  constructor(value) {
    super(value);
  }
}

SortOrder.init({
  EMPTY: '',
  ASCENDING: 'asc',
  DESCENDING: 'desc'
}, {
  EMPTY: 'sort-order.empty',
  ASCENDING: 'sort-order.ascending',
  DESCENDING: 'sort-order.descending',
});

export default SortOrder;
